import React from 'react'
import {NewRouteTemplate} from 'server/functions/route/route.types.js'
import {H6} from '@components/UI/index.js'
import {formSpacing, FormStack, Select, Toggle} from '@components/UI/forms/index.js'
import t from 'src/helpers/Languages.js'

type RouteCalculationsProps = {
    template: NewRouteTemplate
    onChange: (template: NewRouteTemplate) => void
}

function RouteCalculations({template, onChange}: RouteCalculationsProps) {
    return (
        <>
            <H6 style={{marginBottom: 12, marginTop: 36}}>{t('routeCalculation')}</H6>
            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                <Toggle
                    label={t('optimizeForTimeslots')}
                    checked={template.routeCalculation.optimizeForTimeslots}
                    onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, optimizeForTimeslots: event.target.checked}})}
                />

                <Select
                    label='Route aanpasbaar door koerier'
                    value={template.routeCalculation.adjustableByMessengerGrouped}
                    onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, adjustableByMessengerGrouped: event.target.value as NewRouteTemplate['routeCalculation']['adjustableByMessengerGrouped']}})}
                >
                    <option value='default'>Gebruik standaard instelling</option>
                    <option value='yes'>Ja</option>
                    <option value='no'>Nee</option>
                </Select>

                {template.routeCalculation.adjustableByMessengerGrouped === 'yes' && (
                    <FormStack style={{paddingLeft: formSpacing.section}}>
                        <Toggle
                            label='Route volgorde wijzigen'
                            checked={template.routeCalculation.adjustableByMessenger}
                            onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, adjustableByMessenger: event.target.checked}})}
                        />

                        <Toggle
                            label='Nieuw adres aanmaken'
                            checked={template.routeCalculation.allowAddAddress}
                            onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, allowAddAddress: event.target.checked}})}
                        />

                        <Toggle
                            label='Eigen opties wijzigen toestaan'
                            checked={template.routeCalculation.allowMessengerEditCustomOptions}
                            onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, allowMessengerEditCustomOptions: event.target.checked}})}
                        />

                        <Select
                            label='Collo toevoegen toestaan'
                            options={[
                                {title: 'Ja', value: 'yes'},
                                {title: 'Alleen bij bezorgen', value: 'deliver'},
                                {title: 'Alleen bij ophalen', value: 'pickup'},
                                {title: 'Nee', value: ''}
                            ]}
                            value={template.routeCalculation.allowAddCollo}
                            onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, allowAddCollo: event.target.value as NewRouteTemplate['routeCalculation']['allowAddCollo']}})}
                        />

                        <Select
                            label='Bestaande rit toevoegen aan route'
                            info='Kies hier of koeriers zelf bekende ritten kunnen toevoegen aan hun route. Een ongeplande rit betekend een rit die niet in een route staat.'
                            value={template.routeCalculation.messengerAddOrderWarning}
                            onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, messengerAddOrderWarning: event.target.value as NewRouteTemplate['routeCalculation']['messengerAddOrderWarning']}})}
                        >
                            <option value='notallowed'>Niet toestaan</option>
                            <option value='allowed'>Toestaan alle ritten</option>
                            <option value='only_today'>Toestaan ritten op vandaag</option>
                            <option value='only_unplanned'>Toestaan ongeplande ritten</option>
                            <option value='only_unplanned_today'>Toestaan voor ongeplande ritten op vandaag</option>
                        </Select>

                        <Toggle
                            label='Toon waarschuwing bij toevoegen bestaande rit'
                            checked={template.routeCalculation.showWarningOnAddExistingOrder}
                            onChange={(event) => onChange({...template, routeCalculation: {...template.routeCalculation, showWarningOnAddExistingOrder: event.target.checked}})}
                        />
                    </FormStack>
                )}

                <Toggle
                    label={t('loadingRequiredBeforeStart')}
                    checked={template.loadingRequiredBeforeStart}
                    onChange={(event) => onChange({...template, loadingRequiredBeforeStart: event.target.checked})}
                />
            </FormStack>
        </>
    )
}

export default RouteCalculations
